import { useRef } from "react";
import { TopBar, useTopBarConfig } from "@ensafely/checker-ui";

/**
 * CloudNavBar wraps the checker TopBar for use on cloud account pages.
 * Account pages don't need check filtering, so we pass empty/stub props
 * for the dashboard-specific filter functionality while keeping the nav
 * bar (logo, navigation links, user menu, theme toggle) fully functional.
 *
 * Cloud customizations (brandName, extraNavItems, userMenuItems, onLogout)
 * are picked up from the TopBarConfigProvider context set in App.tsx.
 */
export function CloudNavBar() {
  const searchRef = useRef<HTMLInputElement | null>(null);
  const topBarConfig = useTopBarConfig();
  return (
    <TopBar
      {...topBarConfig}
      search=""
      onSearchChange={() => {}}
      statusFilter="all"
      onStatusFilterChange={() => {}}
      projectFilter="all"
      onProjectFilterChange={() => {}}
      typeFilter="all"
      onTypeFilterChange={() => {}}
      projects={[]}
      checkTypes={[]}
      searchRef={searchRef}
    />
  );
}
